import { apiClient } from '@/shared/lib/apiClient';
import type {
  ApiResponse,
  GuideAvailability,
  GuideAvailabilityStatus,
  GuideSchedule,
} from '@/types';

export interface AvailabilityListParams {
  from?: string;
  to?: string;
  status?: GuideAvailabilityStatus;
}

export interface CreateAvailabilityPayload {
  date: string;
  status: GuideAvailabilityStatus;
  notes?: string;
}

export interface BlockAvailabilityRangePayload {
  from: string;
  to: string;
  notes?: string;
}

export interface UpdateAvailabilityPayload {
  date?: string;
  status?: GuideAvailabilityStatus;
  notes?: string;
}

export const guideAvailabilityApi = {
  async list(params: AvailabilityListParams) {
    const response = await apiClient.get<ApiResponse<GuideAvailability[]>>('/guide/availability', {
      params,
    });
    return response.data.data ?? [];
  },

  async create(payload: CreateAvailabilityPayload) {
    const response = await apiClient.post<ApiResponse<GuideAvailability>>(
      '/guide/availability',
      payload
    );
    return response.data.data!;
  },

  async blockRange(payload: BlockAvailabilityRangePayload) {
    const response = await apiClient.post<ApiResponse<GuideAvailability[]>>(
      '/guide/availability/block-range',
      payload
    );
    return response.data.data ?? [];
  },

  async update(id: string, payload: UpdateAvailabilityPayload) {
    const response = await apiClient.put<ApiResponse<GuideAvailability>>(
      `/guide/availability/${id}`,
      payload
    );
    return response.data.data!;
  },

  async remove(id: string) {
    await apiClient.delete(`/guide/availability/${id}`);
  },

  async getSchedule(params: { from: string; to: string }) {
    const response = await apiClient.get<ApiResponse<GuideSchedule>>('/guide/schedule', {
      params,
    });
    return response.data.data!;
  },
};

export const guideAvailabilityKeys = {
  all: ['guide-availability'] as const,
  range: (params?: AvailabilityListParams) => [...guideAvailabilityKeys.all, 'range', params] as const,
  schedule: (params: { from: string; to: string }) =>
    [...guideAvailabilityKeys.all, 'schedule', params] as const,
};
